import React, { useState, useEffect } from 'react';
import { db } from '../FireBase'; // Import Firestore
import { doc, getDoc, setDoc } from 'firebase/firestore';
import { Form, Button, Container } from 'react-bootstrap';
import ToastAlert from '../components/ToastAlert';  

const ContactSettings = () => {
    const [contactInfo, setContactInfo] = useState({
        phone: '',
        email: '',
        address: '',
        facebook: '',
        instagram: ''
    });
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastVariant, setToastVariant] = useState('success');

    useEffect(() => {
        fetchContactInfo();
    }, []);

    const fetchContactInfo = async () => {
        const docRef = doc(db, 'settings', 'contact');
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
            setContactInfo(docSnap.data());
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setContactInfo({ ...contactInfo, [name]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const docRef = doc(db, 'settings', 'contact');
        await setDoc(docRef, contactInfo);
        setToastMessage('Contact information updated successfully!');
        setToastVariant('success'); // or 'danger', 'warning', etc.
        setShowToast(true);
    };

    return (
        <Container>
            <ToastAlert
            show={showToast}
            setShow={setShowToast}
            message={toastMessage}
            variant={toastVariant}
            />

            <Form onSubmit={handleSubmit}>
            <Form.Group controlId="formAddress">
                    <Form.Label>Address</Form.Label>
                    <Form.Control
                        as="textarea"
                        rows={3}
                        name="address"
                        value={contactInfo.address}
                        onChange={handleChange}
                        placeholder="Enter address"
                    />
                </Form.Group>
                <Form.Group controlId="formPhone">
                    <Form.Label>Phone</Form.Label>
                    <Form.Control
                        type="text"
                        name="phone"
                        value={contactInfo.phone}
                        onChange={handleChange}
                        placeholder="Enter phone number"
                    />
                </Form.Group>
                <Form.Group controlId="formEmail">
                    <Form.Label>Email</Form.Label>
                    <Form.Control
                        type="email"
                        name="email"
                        value={contactInfo.email}
                        onChange={handleChange}
                        placeholder="Enter email"
                    />
                </Form.Group>
             
                <Form.Group controlId="formFacebook">
                    <Form.Label>Facebook</Form.Label>
                    <Form.Control
                        type="text"
                        name="facebook"
                        value={contactInfo.facebook}
                        onChange={handleChange}
                        placeholder="Enter Facebook link"
                    />
                </Form.Group>
                
                <Form.Group controlId="formInstagram">
                    <Form.Label>Instagram</Form.Label>
                    <Form.Control
                        type="text"
                        name="instagram"
                        value={contactInfo.instagram}
                        onChange={handleChange}
                        placeholder="Enter Instagram link"
                    />
                </Form.Group>
                <br />
                <Button variant="success" type="submit">
                    Save
                </Button>
            </Form>
        </Container>
    );
};

export default ContactSettings;